// actions.ts — runs a write-endpoint POST for the management buttons (set-primary / delete).
// Prefers the global queryData() (template.js) so the action keeps the exact CSRF / side-log
// behavior the legacy inline onclick handlers had; falls back to a plain fetch if it's absent.
// show_loader is forced off — responses land in the hidden #div_item_media_status sink.

export function runAction(
    url: string,
    payload: Record<string, unknown>,
    statusDivId: string,
): Promise<unknown> {
    const q = window.queryData;
    if (typeof q === 'function') {
        return Promise.resolve(q(url, statusDivId || null, payload, true, false));
    }
    return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
}
